
import deepEyeLogo from "../images/other/deepeye_logo.png";
import deepEyeBanner1 from "../images/other/deepeye_banner1.png";
import deepEyeBanner2 from "../images/other/deepeye_banner2.png";
import deepEyeBanner3 from "../images/other/deepeye_banner3.png";

import retinaLogo from "../images/other/retina_logo.png";
import retinaBanner1 from "../images/other/retina_banner1.png";
import retinaBanner2 from "../images/other/retina_banner2.png";
import retinaBanner3 from "../images/other/retina_banner3.png";

import altrisLogo from "../images/other/altris_logo.png";
import altrisBanner1 from "../images/other/altris_banner1.png";
import altrisBanner2 from "../images/other/altris_banner2.png";
import altrisBanner3 from "../images/other/altris_banner3.png";
import { fileBaseUrl } from "../../constants";

const vendorData = {
    data: [
        {
            "id": "deepeye",
            "vendorName": "deepeye",
            "vendorInfo": "AI-Powered GA Analysis Tools for Research",
            "description":"AI-Powered GA Analysis Tools for Research.",
            "logoUrl": deepEyeLogo,
            "ssonEnabled": true,
            "compatibility": {
                "type": "DICOM",
                "info": "Heidelberg | Zeiss | Topcon"
            },
            "contactUs": {
                emailAddress: "support@deepeye-medical.com",
                backgroundColor: "#113C774D",
                textColor: "#1E1E22"
            },
            "features": [
                {
                    "featureMain": "AI-Driven Insights:",
                    "featureContent": "Provide detection and location of Geographic Atrophy secondary to late-stage macular degeneration."
                },
                {
                    "featureMain": "Disease Insights:",
                    "featureContent": "AI-driven tools to determine foveal involved or sparing geographic atrophy."
                },
                {
                    "featureMain": "Automated reports:",
                    "featureContent": " One click provides research-ready reports."
                }
            ],
            "imageList": [
                {
                    "url": deepEyeBanner1
                },
                {
                    "url": deepEyeBanner2
                },
                {
                    "url": deepEyeBanner3
                } 
            ],
            "reviews": {
                "clinicianReviews":[
                    {
                        "reviewInfo": "“GA observer helped enhance the understanding of Geographic Atrophy.”",
                        "reviewer": ""
                    },
                    {
                        "reviewInfo":"“It determines foveal involvement or foveal sparing in Geographic Atrophy as a key differentiator in disease staging and severity assessment.”",
                        "reviewer":""
                    }
                ],

            },
            "demoVideoUrl": fileBaseUrl +  "/static/media/deepeye/video/Deepeye GAO - Demo Video Updated 03.18.mp4",
        },
        {
            "id": "RetinAI Discovery®",
            "vendorName": "RetinAI Discovery®",
            "vendorInfo": "Access Discovery for an AI-Powered OCT Analysis & Therapy Planning.  Streamline the collection, organization and analysis of your OCT data.",
            "description":"Advanced OCT Analysis Platform to Detect, Track and Predict GA Progression.",
            "logoUrl": retinaLogo,
            "ssonEnabled": false,
            "compatibility": {
                "type": "OCT IMAGING",
                "info": "Heidelberg | Zeiss | Topcon | Optos | All major OCT systems"
            },
            "contactUs": {
                emailAddress: "support@retinai.com",
                backgroundColor: "#ECEFF4",
                textColor: "#1E1E22"
            },
            "features": [
                {
                    "featureMain": "AI-Powered GA Detection & Biomarker Analysis:",
                    "featureContent": "Detects Hypertransmission, RPE atrophy, EZ disruption, and Neurosensory retina thinning."
                }
            ],
            "imageList": [
                {
                    "url": retinaBanner1
                },
                {
                    "url": retinaBanner2
                },
                {
                    "url": retinaBanner3
                } 
            ],
            "reviews": {
            "clinicianReviews":[
                {
                    "reviewInfo": "“The Discovery platform is easy to use and provides useful metrics for AMD, in particular the progression analysis of geographic atrophy”",
                    "reviewer": "- Dr. Trusit Dave, PhD, BSc(Hons), DipTp(IP), Prof Cert Glauc, MCOptom, FAAO."
                }
            ]
           },
           "demoVideoUrl": fileBaseUrl + "/static/media/retinai/video/RetinAI - Demo Video Updated 03.18.mp4",
        },
        {
            "id": "Altris AI",
            "vendorName": "Altris AI",
            "vendorInfo": "An AI-powered platform for interpreting OCT scans, enhancing patient workflow efficiency and assisting optometrists in detecting geographic atrophy (GA) and identifying GA biomarkers.",
            "description":"AI-powered decision support for optometrists to streamline referrals.",
            "logoUrl": altrisLogo,
            "ssonEnabled": true,
            "compatibility": {
                "type": "OCT IMAGING",
                "info": "Topcon | Optopol | Heidelberg Engineering | Nidek | Canon | Optovue | Other Major OCT Systems"
            },
            "contactUs": {
                emailAddress: "support@altris.ai",
                backgroundColor: "#3FB1AF4D",
                textColor: "#1E1E22"
            },
            "features": [
                {
                    "featureMain": "AI-Powered GA Biomarker Detection:",
                    "featureContent": "Identifies GA biomarkers, measures their area and volume, determines the distance from the fovea to GA, and assesses GA coverage within 1mm, 3mm, and 6mm zones."
                },
                {
                    "featureMain": "Advanced GA Progression Analysis:",
                    "featureContent": "Tracks how GA changes over time with precise pathology monitoring. Allows to review how each biomarker changes over every examination."
                },
                {
                    "featureMain": "AI-Powered OCT Workflow Optimization:",
                    "featureContent": "Prioritizes scans based on pathology severity."
                },
                {
                    "featureMain": "Pathology Detection, Layer Analysis, and Macula Thickness Measurement:",
                    "featureContent": "Provides a comprehensive list of detected pathologies and biomarkers from the examination, visualizes retinal layer segmentation, and measures macula thickness within 1mm, 3mm, and 6mm zones."
                }
            ],
            "imageList": [
                {
                    "url": altrisBanner1
                },
                {
                    "url": altrisBanner2
                },
                {
                    "url": altrisBanner3
                } 
            ],
            "reviews": {
                "clinicianReviews":[
                {
                    "reviewInfo": "“Altris AI identified pathology that I could not. It helped me avoid over-referring and detect early-stage cases that changed treatment plans.”",
                    "reviewer": "- Scott Sedlacek, OD"
                },
                {
                    "reviewInfo":"“We are adding a new OCT and may benefit from AI to speed up interpretation and assist our busy optometry team.”",
                    "reviewer":"- Richard Clare, Optometry Owner"
                }
            ]
            },
            "demoVideoUrl": fileBaseUrl + "/static/media/altrisai/video/Altris - Demo Video Updated 3.18.mp4",
        }
    ]
};


export default vendorData;
